import PropTypes from 'prop-types';
import sx from '@styled-system/css';
import shouldForwardProp from '@styled-system/should-forward-prop';
import variant from '@styled-system/variant';
import styled from '@emotion/styled';
import Base from './base';
import { STYLE } from './shared';

const Button = styled(Base, { shouldForwardProp })(
  ({ variant = 'default', disabled = false }) => {
    return sx({
      color: 'white',
      ...STYLE(disabled),
    });
  },
  variant({
    variants: {
      default: {
        backgroundColor: 'grays.0',
        '&:hover': {
          backgroundColor: 'black',
        },
        '&:active': {
          boxShadow: theme => `inset 0 0 0 1px ${theme.colors.grays[0]}`,
          backgroundColor: 'grays.1',
        },
      },
      primary: {
        backgroundColor: 'indigos.3',
        '&:hover': {
          backgroundColor: 'indigos.2',
        },
        '&:active': {
          boxShadow: theme => `inset 0 0 0 1px ${theme.colors.indigos[1]}`,
        },
      },
      alt: {
        backgroundColor: 'grays.6',
        color: 'grays.0',
        '&:hover': {
          backgroundColor: 'grays.5',
        },
        '&:active': {
          boxShadow: theme => `inset 0 0 0 1px ${theme.colors.grays[4]}`,
        },
      },
    },
  }),
);

Button.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOfType([
    PropTypes.oneOf(['default', 'primary', 'alt']),
    PropTypes.arrayOf(PropTypes.oneOf(['default', 'primary', 'alt'])),
  ]),
  size: PropTypes.oneOfType([
    PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
    PropTypes.arrayOf(PropTypes.oneOf(['xs', 'sm', 'md', 'lg'])),
  ]),
  disabled: PropTypes.bool,
};

Button.defaultProps = {
  variant: 'default',
  size: 'md',
  disabled: false,
};

Button.displayName = 'Monterey(Button)';

export default Button;
